import { useContext } from 'react'

import { CustomEmojiContext } from '../providers/CustomEmojiProvider'

export const useCustomEmojiContext = () => {
  const customEmojiContext = useContext(CustomEmojiContext)

  if (customEmojiContext === undefined) {
    throw new Error('customEmojiContext must be used within a CustomEmojiProvider')
  }

  return customEmojiContext
}
